import { render, staticRenderFns } from "./user_center_pwd.vue?vue&type=template&id=4ec76fe6&scoped=true"
import script from "./user_center_pwd.vue?vue&type=script&lang=js"
export * from "./user_center_pwd.vue?vue&type=script&lang=js"
import style0 from "./user_center_pwd.css?vue&type=style&index=0&id=4ec76fe6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec76fe6",
  null
  
)

export default component.exports